import { Flex, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { IconTypeOrIconString } from 'src/app/types'
import { Icon } from 'src/chrome'

type PaperTypeTileProps = {
  title: string
  imageUrl: string
  price: string
  icon?: IconTypeOrIconString
  size?: string
  onSelect: (isSelected: boolean) => void
  isSelected: boolean
}

export const PaperTypeTile = (props: PaperTypeTileProps) => {
  const { title, price, icon, size = '5.25rem', onSelect, isSelected } = props

  const primaryFont = 'Montserrat, san serif'

  const handleSelect = () => {
    onSelect(isSelected)
  }

  return (
    <Flex
      cursor="pointer"
      position="relative"
      flexDirection="column"
      width={size}
      onClick={handleSelect}
      opacity={isSelected ? 1 : 0.7}
      rowGap="x2"
      style={{
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        borderRadius: '.25rem',

        border: isSelected
          ? '3px solid #8fc3ff'
          : '2px solid rgba(233, 233, 233, 0.70)',
      }}
    >
      <Flex width="100%" justifyContent="flex-end">
        <Flex
          position="relative"
          width="fit-content"
          right="6px"
          top="6px"
          backgroundColor={isSelected ? '#333' : '#DCDCDC'}
          inset={{ horizontal: '.5rem' }}
          style={{ borderRadius: '30px' }}
        >
          <Text
            type="body"
            content={price}
            lineHeight={1.5}
            style={{
              fontFamily: primaryFont,
              fontSize: '.625rem',
              fontWeight: 700,
              color: isSelected ? '#fff' : '#404040',
            }}
          />
        </Flex>
      </Flex>
      {icon && (
        <Flex justifyContent="center" alignItems="center" height="100%">
          <Icon
            icon={icon}
            stroke={isSelected ? '#444444' : '#DCDCDC'}
            color={isSelected ? '#444444' : '#DCDCDC'}
            size={70}
            viewBox="0 0 25 32"
            style={{
              right: 6,
              bottom: '30%',
              background: 'rgba(0, 0, 0, 0.03)',
            }}
          />
        </Flex>
      )}
      <Flex
        backgroundColor={isSelected ? '#fff' : '#DCDCDC'}
        borderRadius="0px 0px 4px 4px"
        justifyContent="center"
        bottom="0px"
        left="0px"
        right="0px"
      >
        <Text
          type="body"
          content={title}
          lineHeight={2.5}
          style={{
            fontFamily: primaryFont,
            fontSize: '.625rem',
            fontWeight: 700,
            color: '#404040',
          }}
        />
      </Flex>
    </Flex>
  )
}
